import { deliveryUnitAPI } from "../../axios";

export const actions = {

    //RealignmentAccount
    CreateRealignmentAccount(context, data){
        return deliveryUnitAPI.post(`RealignmentAccount/Create/Multiple`, data);
    },
    GetAllRealignmentAccount(context, data){
        return deliveryUnitAPI.get(`RealignmentAccount/All/${data}`);
    },
    UpdateRealignmentAccount(context, data){
        return deliveryUnitAPI.put(`RealignmentAccount/Update/${data.id}`, data);
    },
    RemoveRealignmentAccount(context, data){
        return deliveryUnitAPI.delete(`RealignmentAccount/Remove/${data}`);
    },
    GetSingleRealignmentAccount(context, data){
        return deliveryUnitAPI.get(`RealignmentAccount/${data}`);
    },
}